import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { AlertController } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { OverlayManagerService } from './overlay-manager.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  // 30 min en milisegundos
  private readonly SESSION_TIMEOUT = 30 * 60 * 1000;

  constructor(
    private authService: AuthService,
    private router: Router,
    private alertController: AlertController,
    private overlayManager: OverlayManagerService
  ) {
    this.SESSION_TIMEOUT = environment.timeOut
      ? environment.timeOut
      : this.SESSION_TIMEOUT;
    console.warn({ SESSION_TIMEOUT: this.SESSION_TIMEOUT });
  }

  /**
   * Actualiza el timestamp de la última actividad
   */
  updateLastActivity(): void {
    localStorage.setItem('lastActivityTime', new Date().getTime().toString());
  }

  /**
   * Verifica si la sesión ha expirado
   * @returns boolean - true si la sesión ha expirado
   */
  isSessionExpired(): boolean {
    const lastActivity = localStorage.getItem('lastActivityTime');
    if (!lastActivity) {
      return false; // Si no hay tiempo registrado, asumimos que no ha expirado
    }

    const currentTime = new Date().getTime();
    const lastActivityTime = parseInt(lastActivity, 10);

    return currentTime - lastActivityTime > this.SESSION_TIMEOUT;
  }

  /**
   * Verifica la sesión y muestra una alerta si ha expirado
   */
  async checkSession(): Promise<void> {
    console.info('checkSession');
    // Si hay un usuario logueado y la sesión ha expirado
    if (localStorage.getItem('currentUser') && this.isSessionExpired()) {
      await this.overlayManager.cleanupForLogout();
      this.logoutUser();
      // await this.showSessionExpiredAlert();
    } else {
      // Actualizar el tiempo de última actividad
      this.updateLastActivity();
    }
  }

  /**
   * Muestra una alerta de sesión expirada y hace logout
   */
  private async showSessionExpiredAlert(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Sesión expirada',
      message: 'Su sesión ha expirado por inactividad',
      buttons: ['Ok'],
    });

    await alert.present();
  }

  /**
   * Cierra la sesión del usuario
   */
  private logoutUser(): void {
    localStorage.removeItem('lastActivityTime');
    this.authService.signOut().then(async () => {
      await this.overlayManager.cleanupForLogout();

      this.router.navigate(['/login'], {
        queryParams: {
          expired: true,
        },
      });
    });
  }
}
